import { useState } from "react";
import "./prechat.css";
import e from "cors";

// --- Main Pre-Chat Component ---
export default function Prechat(props) {
    // State to hold the email input's current value
    const [email, setEmail] = useState('');
    // State to hold the validation error message
    const [emailError, setEmailError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // The name of the field, which we'll use for form submission
    const fieldName = 'メールアドレスを入力してください';

    // This is a regular expression to check for a valid email format
    const validateEmail = (email) => {
        if (!email) return false; // Fails if email is empty
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const validateEmailSuffix = (email) => {
        const legalSuffixes = ['salesforce.com', 'sohobb.jp'];
        const suffix = String(email).split('@')[1];
        return legalSuffixes.includes(suffix);
    }

    // --- This function runs every time the user types in the input ---
    const handleEmailChange = (event) => {
        const newEmail = event.target.value;
        setEmail(newEmail); // Update the email's value in our state

        // Check for an error as they type
        if (newEmail && !validateEmail(newEmail)) {
            setEmailError('有効なメールアドレスを入力してください。');
        } else {
            setEmailError('');
        }
    };

    // --- This function runs when the form is submitted ---
    // In src/components/prechat.js

    const handlePrechatFormSubmit = async (event) => {
        event.preventDefault();

        if (!validateEmail(email) | !validateEmailSuffix(email)) {
            setEmailError('メールアドレス無効です。会社のメールアドレスをご入力ください。');
            return;
        }

        setEmailError('');
        setIsLoading(true);

        try {
            // --- SECURITY WARNING ---
            // This authentication logic should be on a backend server, not here.
            // Your client_secret and password are exposed to the public.

            const urlencoded = new URLSearchParams();

            const client_id = process.env.REACT_APP_CLIENT_ID;
            const client_secret = process.env.REACT_APP_CLIENT_SECRET;
            const username = process.env.REACT_APP_USERNAME;
            const password = process.env.REACT_APP_PASSWORD;
            urlencoded.append("grant_type", "password");
            urlencoded.append("client_id", client_id);
            urlencoded.append("client_secret", client_secret);
            urlencoded.append("username", username);
            urlencoded.append("password", password);

            const requestOptions = {
                method: "POST",
                // The header 'Content-Type' is automatically set by the browser
                // when using URLSearchParams in the body, so it's not needed here.
                body: urlencoded,
            };


            // 1. Await the fetch call and store the result in 'response'
            const url = process.env.REACT_APP_TOKEN_URL
            const response = await fetch(url, requestOptions);

            // 2. Check if the server responded with an error
            if (!response.ok) {
                const errorData = await response.json();
                console.error('Salesforce auth error:', errorData);
                throw new Error('Login failed. Please check your credentials.');
            }

            // 3. Get the JSON data from the successful response
            const data = await response.json();
            console.log('Login successful, received access token');

            // 4. Now that authentication is successful, proceed to the chat page
            props.onPrechatSubmit({ [fieldName]: email, 'authToken': data.access_token });

        } catch (error) {
            console.error('Login process error:', error);
            setEmailError(error.message || 'An unexpected error occurred.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="messagingPrechat">
            <h2 className="prechat-title">ようこそ　SOHOBBエージェントへ</h2>
            <form className="prechatForm" onSubmit={handlePrechatFormSubmit}>
                <ul className="prechatFormFieldsListView">
                    <li className="prechatFormFieldContainer">
                        <p className="prechatFormFieldName">{fieldName}
                            <span className="requiredFieldIndicator">*</span>
                        </p>

                        {/* The Controlled Input Field */}
                        <input
                            className={`prechatFormField email ${emailError ? 'input-error' : ''}`}
                            name={fieldName}
                            type="email"
                            placeholder="you@example.com"
                            // The input's value is now controlled by React state
                            value={email}
                            // The handleEmailChange function is called on every keystroke
                            onChange={handleEmailChange}
                        />

                        {/* The error message appears here if it exists */}
                        {emailError && <p className="error-message">{emailError}</p>}
                    </li>
                </ul>
                <button
                    type="submit"
                    className="startConversationButton"
                    disabled={isLoading}>
                    {isLoading ? 'Logging In...' : '問い合わせを開始'}
                </button>
            </form>
        </div>
    );
}